import React, { useState , useEffect } from "react";
import '../../styles/header.css'
import Sidebar from './Sidebar.jsx';
import GoogleTranslate from "./googletranslator.jsx";
import { FaGooglePlay } from "react-icons/fa";
import { FaApple } from "react-icons/fa";
import { FaDownload } from "react-icons/fa";
import { NavLink } from "react-router-dom";
const menuItems = [
  {
    title: "హోమ్",
    href: "/",
  },

  {
    title: "తాజా వార్తలు",
    href: "/contents/latestnews-25.html",
  },

  {
    title: "రాజకీయం",
    href: "/contents/politics-39.html",
  },

  {
    title: "ఆంధ్రప్రదేశ్",
    href: "/contents/andhrapradesh-43.html",
  },

  {
    title: "తెలంగాణ",
    href: "/contents/telangana-24.html",
  },

  {
    title: "భారత్",
    href: "/contents/india-23.html",
  },

  {
    title: "ప్రపంచం",
    href: "/contents/world-58.html",
  },

  {
    title: "బిజినెస్",
    href: "/contents/business-54.html",
  },

  {
    title: "టెక్నాలజీ",
    href: "/contents/technology-33.html",
  },

  {
    title: "క్రీడలు",
    href: "/contents/sports-53.html",
  },

  

  {
    title: "మరిన్ని ▾",
    href: "",
    submenu: [
      {
    title: "తెలుగువన్ ప్రత్యేకం",
    href: "/contents/teluguoneexclusive-55.html",
  },

  {
    title: "చరిత్ర",
    href: "/contents/history-57.html",
  },

  {
    title: "సంపాదకీయం",
    href: "/contents/analytical-45.html",
  },
    ],
  },
];


const mobileMenuItems = menuItems.flatMap((item) =>
  item.submenu ? item.submenu : [item]
);

function Header({mobile}) {
 
  const [open, setOpen] = useState(false);
  const [appDownloadOpen, setAppDownloadOpen] = useState(false);
  const itemsToRender = mobile ? mobileMenuItems : menuItems;
  const [adJson ,setAdJson] = useState(null)

 useEffect(() => {
    fetch("https://www.teluguone.com/teluguone-ssr-server/ad.php")
     .then(res => res.json())
     .then(data => setAdJson(data))
     .catch(err => console.error(err));
   }, []);
 


 

  return (
    <header className="home-header">
     
      <div className="home-header-main">
         <button
      className="touch-menu-btn"
      onClick={() => setOpen(true)}
    >
      ☰
    </button>
        <div className="header-logo-div">
          <a href="https://teluguone.com/" aria-label="TeluguOne Home">
            <img
              src="/news/assets/images/header_logo_200x100_3.png"
              loading="lazy"
              alt="TeluguOne Logo"
              className="header-logo"
            />
          </a>
        </div>

        <div className="header-banner">
         {adJson ? <a href={adJson.adLink} target="_blank" rel="noreferrer">
            <img src={adJson.adImg} alt="TeluguOne Health" fetchpriority="high" /> </a> :
          <a href="#" target="_blank" rel="noreferrer">
           <img src="https://www.teluguone.com/images/toneApp-1.webp" alt="TeluguOne Health"  fetchpriority="high" />
          </a>
          }
        </div>
        <div className="header-social"> <a href="https://whatsapp.com/channel/0029Va4fv6gLI8YahK6tsU1o" target="_blank">
                <svg className="whatsapp icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path className="fill-transition" fillRule="evenodd" clipRule="evenodd" d="M14.5804 3.41368C13.8523 2.68526 12.9873 2.10805 12.0353 1.71526C11.0833 1.32248 10.0629 1.12187 9.03305 1.12501C4.71094 1.12501 1.1925 4.62586 1.19074 8.92969C1.18881 10.3001 1.55006 11.6466 2.2377 12.832L1.125 16.875L5.28223 15.7897C6.43295 16.4132 7.72112 16.7395 9.02988 16.739H9.03305C13.3548 16.739 16.8729 13.2377 16.875 8.93426C16.8776 7.9079 16.6761 6.89126 16.2822 5.9435C15.8882 4.99574 15.3097 4.13579 14.5804 3.41368ZM9.03305 15.4216H9.03023C7.86353 15.422 6.71804 15.1098 5.71289 14.5174L5.47488 14.3768L3.00797 15.0209L3.66645 12.6271L3.51141 12.381C2.85904 11.3482 2.51341 10.1513 2.51473 8.92969C2.51473 5.35325 5.44008 2.44336 9.03551 2.44336C10.7603 2.44029 12.4156 3.12242 13.6375 4.33974C14.8594 5.55705 15.5477 7.20985 15.551 8.93461C15.5496 12.5114 12.6257 15.4216 9.03305 15.4216ZM12.6081 10.5634C12.4123 10.4657 11.4479 9.99387 11.2693 9.92883C11.0907 9.8638 10.9589 9.8311 10.8285 10.0266C10.698 10.222 10.3222 10.6594 10.208 10.7912C10.0937 10.9231 9.97945 10.9375 9.78363 10.8397C9.58781 10.742 8.95606 10.5363 8.20758 9.87188C7.62504 9.35473 7.23199 8.71629 7.11773 8.52118C7.00348 8.32606 7.10543 8.22024 7.20352 8.12321C7.29176 8.03567 7.39934 7.8954 7.49742 7.78149C7.59551 7.66758 7.6282 7.58602 7.69324 7.45594C7.75828 7.32586 7.72594 7.21196 7.67707 7.11458C7.6282 7.01719 7.23621 6.05708 7.07309 5.66649C6.91383 5.2861 6.75246 5.33778 6.63223 5.3318C6.51797 5.32618 6.38613 5.32477 6.25641 5.32477C6.15723 5.32735 6.05966 5.35035 5.96977 5.39233C5.87989 5.43431 5.79962 5.49437 5.73398 5.56876C5.55434 5.76422 5.04809 6.23672 5.04809 7.19579C5.04809 8.15485 5.75121 9.08297 5.84824 9.21305C5.94527 9.34313 7.22988 11.3129 9.19547 12.1577C9.56046 12.3141 9.93339 12.4511 10.3127 12.5684C10.7821 12.7167 11.2092 12.696 11.5467 12.6457C11.9232 12.5898 12.7069 12.1739 12.8696 11.7183C13.0324 11.2627 13.0328 10.8724 12.9839 10.7912C12.935 10.71 12.8043 10.6608 12.6081 10.5634Z" fill="#241717"></path> </svg> </a>
             <a href="https://www.facebook.com/profile.php?id=61587106207168" target="_blank"> 
                <svg className="facebook icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path className="fill-transition" d="M11.486 3.99003H12.896V1.60503C12.2133 1.53389 11.5274 1.49884 10.841 1.50003C8.80102 1.50003 7.40602 2.74503 7.40602 5.02503V6.99003H5.10352V9.66003H7.40602V16.5H10.166V9.66003H12.461L12.806 6.99003H10.166V5.28753C10.166 4.50003 10.376 3.99003 11.486 3.99003Z" fill="#241717"></path> </svg> </a> 
            <a href="https://www.instagram.com/teluguone/?hl=en" target="_blank">
                <svg className="instagram icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path className="stroke-transition" d="M1.875 9C1.875 5.6415 1.875 3.9615 2.91825 2.91825C3.9615 1.875 5.64075 1.875 9 1.875C12.3585 1.875 14.0385 1.875 15.0817 2.91825C16.125 3.9615 16.125 5.64075 16.125 9C16.125 12.3585 16.125 14.0385 15.0817 15.0817C14.0385 16.125 12.3593 16.125 9 16.125C5.6415 16.125 3.9615 16.125 2.91825 15.0817C1.875 14.0385 1.875 12.3593 1.875 9Z" stroke="#241717" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"></path> <path className="stroke-transition" d="M13.131 4.875H13.1235M12.375 9C12.375 9.89511 12.0194 10.7535 11.3865 11.3865C10.7535 12.0194 9.89511 12.375 9 12.375C8.10489 12.375 7.24645 12.0194 6.61351 11.3865C5.98058 10.7535 5.625 9.89511 5.625 9C5.625 8.10489 5.98058 7.24645 6.61351 6.61351C7.24645 5.98058 8.10489 5.625 9 5.625C9.89511 5.625 10.7535 5.98058 11.3865 6.61351C12.0194 7.24645 12.375 8.10489 12.375 9Z" stroke="#241717" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"></path> </svg> </a> 
            <a href="https://x.com/Theteluguone?lang=en" target="_blank">
                 <svg className="twitter icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path className="stroke-transition" d="M2.25 15.75L7.911 10.089M7.911 10.089L2.25 2.25H6L10.089 7.911M7.911 10.089L12 15.75H15.75L10.089 7.911M15.75 2.25L10.089 7.911" stroke="#241717" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"></path> </svg> </a> 
            <a href="https://x.com/ToneNewsLive" target="_blank" className="header-social-tweets-anchor">&#9679; # Tweets</a>    
                  <button
          type="button"
          className="app-download-btn"
          onClick={() => setAppDownloadOpen(true)}
        >
          <FaDownload  className="i" /> Download Mobile App
        </button>
       </div>
       <div className={`app-download-overlay ${appDownloadOpen ? "active" : ""}`} onClick={() => setAppDownloadOpen(false)} >
              <div className="app-download-popup"  onClick={(e) => e.stopPropagation()} >
                  <button
                    type="button"
                    className="app-download-close"
                    aria-label="Close"
                    onClick={() => setAppDownloadOpen(false)}
                  >
                    &times;
                  </button>
                  <h3 className="poppins-semibold">Download the TeluguOne App</h3>
                  <p>Choose your platform to continue</p>
                  <div className="app-download-options">
                      <a href="https://play.google.com/store/apps/details?id=com.teluguone.newsapp&hl=en_IN" target="_blank" className="app-download-option android">
                          <FaGooglePlay className="i" />
                          <span>Android</span>
                      </a>
                      <a href="https://apps.apple.com/in/app/teluguone/id600801946" target="_blank" className="app-download-option ios">
                          <FaApple className="i" />
                          <span>iOS</span>
                      </a>
                  </div>
              </div>
       </div>
        
      </div>

       <GoogleTranslate />

      {/* Navigation */}
     <nav className="header-links-container">
  {itemsToRender.map((item) => (
    <div
      className="main-dropdown"
      key={item.title}
    >
      <div className="header-link-wrapper">
        {item.submenu ? (
          <div
            className="header-link notranslate"
            style={{ cursor: "default" }}
          >
            {item.title}
          </div>
        ) : (
          <NavLink
            to={item.href}
            className={({ isActive }) =>
              `header-link notranslate ${isActive ? "active-page" : ""}`
            }
            rel="noreferrer"
          >
            {item.title}
          </NavLink>
        )}
      </div>

      {/* Only desktop menu will have submenu */}
      {item.submenu && (
        <div className="header-submenu-wrapper">
          {item.submenu.map((subItem, subIndex) => (
            <NavLink
              to={subItem.href}
              className={({ isActive }) =>
                `header-link notranslate ${isActive ? "active-page" : ""}`
              }
              rel="noreferrer"
              key={subItem.href || subIndex}
            >
              {subItem.title}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  ))}
         </nav>
      
     <Sidebar
    open={open}
    onClose={() => setOpen(false)}
  />

    </header>
  );
}

export default Header;